import { createProductSearchGrid } from './BaseProductSearchGrid.js';
import { createProductConfig } from '@js/algolia/createProductConfig.js';
import { robotAndGoConfig } from '@js/config/algolia.js';

function getSpecs(_result) {
  return [];
}

function hasSpecs(_result) {
  return false;
}

function formatCardData(result) {
  return {
    heading: result.title || '',
    url: result.absoluteUri || result.url || '#',
    image: result.productImage || null,
    category:
      result.solutionCreatorName && result.solutionCreatorName.length
        ? result.solutionCreatorName[0]
        : null,
    description: result.description || result.tagline || null,
    truncateDescription: true,
    attributes: [],
    legacy: false,
    controllerSeries: [],
  };
}

export default createProductSearchGrid({
  appId: robotAndGoConfig.app_id,
  apiKey: robotAndGoConfig.api_key,
  indexName: robotAndGoConfig.index,
  configureWidget: createProductConfig('[data-search-robot-and-go]'),
  formatCardData,
  getSpecs,
  hasSpecs,
  scrollToSelector: '[data-search-robot-and-go]',
});
